<template>
  <v-dialog persistent v-model="showQrCodePopup" max-width="300">
    <v-card max-width="300" class="px-4 pt-2 pb-4">
      <div class="px-3 pt-3 mb-n3 d-flex justify-end">
        <v-icon class="cursor-pointer" @click="closeQrCodePopup()"
          >mdi-close</v-icon
        >
      </div>
      <div class="d-flex justify-center mb-4 mt-6">
        <qrcode-vue ref="qrcode" :size="200" :value="qrCodeValue"></qrcode-vue>
      </div>
      <div class="d-flex flex-column align-center">
        <p class="mb-0 pb-0 caption">{{ lang.profile.scanQrCodeFor }}</p>
        <h4 class="font-weight-bold">
          {{ `${personMetrics.deceasedFullName}` }}
        </h4>
      </div>
      <div class="justify-center align-center d-flex mt-4">
        <v-btn class="btn-bg" small elevation="0" @click="downloadQrCode()">{{
          lang.actions.download
        }}</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import QrcodeVue from "qrcode.vue";
export default {
  name: "ShowQrCodeDialog",
  components: {
    QrcodeVue,

  },
  props: {
    qrCodeValue: {
      type: String,
      default: "",
    },
    showQrCodePopup: {
      type: Boolean,
      default: false,
    },
    personMetrics: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  methods: {
    closeQrCodePopup() {
      this.$emit("closeQrCodePopup");
    },
    downloadQrCode() {
      this.$emit("downloadQrCode", this.$refs);
    },
  },
  computed: {
    lang() {
      return this.$store.state.langObj || {};
    },
  },
};
</script>
